import React, { useEffect, useState } from "react";
import moment from "jalali-moment";
import { isEmpty } from "lodash";
import { DtPicker } from 'react-calendar-datetime-picker';
import 'react-calendar-datetime-picker/style.css';

const CustomDateTimePicker = ({
  className = "form-control-lg form-control",
  onChange = () => {},
  onBlur,
  initValue,
  isDisabled,
  ...props
}) => {
  const [val, setVal] = useState({
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
  });

  const getConvertDate = (value) => {
    if (value && value.year) {
      return moment(
        `${value.year}-${value.month}-${value.day} ${value.hour}:${value.minute}`,
        "jYYYY-jMM-jDD HH:mm"
      ).toDate();
    }
    return null;
  };

  // 1. Output Handler (Converts Jalali state back to Gregorian JS Date for the form)
  useEffect(() => {
    if (!isEmpty(val) && val.year) {
      const dateNow = new Date();
      const convertDateObj = getConvertDate(val);

      if (convertDateObj) {
        // Prevent bugs with dates from 100+ years ago (Unix epoch artifacts)
        dateNow.setFullYear(dateNow.getFullYear() - 100);

        if (dateNow.getTime() < convertDateObj.getTime()) {
          onChange(convertDateObj);
          if (onBlur) onBlur();
        }
      }
    }
  }, [val]);

  // 2. Input Handler (Parses backend Jalali string safely into the picker's state)
  useEffect(() => {
    if (!initValue) return;

    let mDate;
    
    // Check if the backend sent a Jalali string (starts with 13xx or 14xx)
    if (typeof initValue === "string" && initValue.match(/^[1][34]\d{2}/)) {
      // Parse Jalali format: "1405-05-30 17:10:00"
      mDate = moment(initValue, "jYYYY-jMM-jDD HH:mm:ss");
    } else {
      // Fallback: If it's a standard JS Date object or a Gregorian string
      mDate = moment(initValue);
    }

    if (mDate && mDate.isValid()) {
      const newVal = {
        year: mDate.jYear(),
        month: mDate.jMonth() + 1, // jalali-moment jMonth is 0-indexed (0-11)
        day: mDate.jDate(),
        hour: mDate.hour(),
        minute: mDate.minute(),
      };

      // Compare exact timestamps to prevent infinite React re-rendering loops
      const currentValTime = getConvertDate(val)?.getTime();
      const newValTime = mDate.toDate().getTime();

      if (currentValTime !== newValTime) {
        setVal(newVal);
      }
    }
  }, [initValue]);

  const inputClass = `${className} ${isDisabled ? "" : "bg-white"} text-left h-25`;

  return (
    <>
      <DtPicker
        local="fa"
        inputClass={inputClass}
        headerClass="bg-primary"
        showWeekend={true}
        clearBtnClass="text-danger"
        onChange={setVal}
        initValue={val}
        isDisabled={isDisabled}
        withTime={true}
        calendarSystem="ja"
        {...props}
      />
    </>
  );
};

export default CustomDateTimePicker;